export default __webpack_public_path__ + "static/figure4-296f4783f79c9b52169eefabfbe6c482.webp";